import { ServerIcon } from '@/lib/janitsjar/Product';
import { BedOpen, Box, ColorPallete, FlatPack, Storage } from '@fagmobler/ui';
import React from 'react';

type Props = {
  icons: ServerIcon[];
};

const ICON_MAP: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>>
> = {
  flat_packed: FlatPack,
  assembled: Storage,
  sofa_bed: Box,
  swivel_and_tilt: Box,
  color_options: ColorPallete,
  extendable_table: Box,
  exclusive_to_fagmobler: Box,
  with_storage: BedOpen,
  reversible_sofa: Box,
};

export function ProductIcons({ icons }: Props) {
  return (
    <div className="flex flex-wrap gap-2 lg:gap-4">
      {icons.map((icon) => {
        const IconComponent = ICON_MAP[icon.key];
        return (
          <div key={icon.key} className="flex flex-row gap-2 items-center">
            {IconComponent && <IconComponent className="size-6" />}
            <span className="body-xs">{icon.label}</span>
          </div>
        );
      })}
    </div>
  );
}
